export const BAR = 'BarChart';
export const ROW = 'RowChart';
export const SCATTER = 'ScatterChart';
export const TIMELINE = 'TimelineChart';
export const H_SYMBOL = 'HorizontalSymbolChart';
export const V_SYMBOL = 'VerticalSymbolChart';
export const STACKED_BAR = 'StackedBarChart';
export const STACKED_ROW = 'StackedRowChart';
export const CHORO = 'ChoroplethChart';
export const PERCENT = 'percent';
export const VALUES = 'values';
export const TYPES = {
  [BAR]: BAR,
  [ROW]: ROW,
  [SCATTER]: SCATTER,
  [TIMELINE]: TIMELINE,
  [H_SYMBOL]: H_SYMBOL,
  [V_SYMBOL]: V_SYMBOL,
  [STACKED_BAR]: STACKED_BAR,
  [STACKED_ROW]: STACKED_ROW,
  [CHORO]: CHORO,
};

export const OBS_TYPE_NUMBER = 'OBS_TYPE_NUMBER';
export const OBS_TYPE_NUMERICAL_STRING = 'OBS_TYPE_NUMERICAL_STRING';
export const OBS_TYPE_STRING = 'OBS_TYPE_STRING';
export const REPORTING_YEAR_START_DAY = 'REPORTING_YEAR_START_DAY';
export const REPYEARSTART = 'REPYEARSTART';
